<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="edisources_new" ttGoto="edisource" [ttGotoParms]="{ edi_source_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListEdiSources"></tt-list>
</tt-page>
